/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate, useParams} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import {
  approveSO,
  getDetailSO,
  printSO,
  rejectSO,
  getPaymentSO,
  getAccesses,
  editSOItem,
  revisionSO,
  unduhSO,
  updateAdditionalText,
} from '../../../api/modules/so'
import {
  getProvince,
  getPlant,
  getFindoc,
  getTOPAnper,
  getTOPCust,
} from '../../../api/modules/getdatalist'
import swal from 'sweetalert'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Country from '../component/DataCountry.json'
import CustomUseEffect from '../content/offer/CustomUseEffect'
import {getDetailFileConfig} from 'src/api/modules/master-data/master'
import {useDispatch, useSelector} from 'react-redux'
import {setGetNotif} from '../../../_metronic/redux/content'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {getPlant2} from '../../../api/modules/getdatalist'
import axios from 'axios'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import i18next from 'i18next'
import {Spinner} from 'react-bootstrap'
import AddRemoveJadwal from '../si/AddRemoveJadwal'
import {PopoverText} from '../../../components/Popover/Popover'
import {
  getRoleFlagList,
  getConfigLetter,
  getBatasTanggalLetter,
} from '../../../api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import {ViewLetter} from '../../../components/Letter/ViewLetter'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {appSelector} from '../../../redux/slices/appSlices'
import {useAppSelector} from '../../../redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'
import {HakAkses} from 'src/components/mikro/getHakAkses'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {soSelector} from 'src/redux/slices/soSlices'
import dateformat from 'src/utils/dateformat'
import * as TableUI from '../../../components/Table/Table'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'
import { RichText } from 'src/components'
const ApprovalSODetail: React.FC = () => {
  const intl = useIntl()
  const {selectedMenu} = useAppSelector(appSelector)
  const {roleId} = useAppSelector(authSelector)
  const hakAkses = HakAkses()

  const [show3, setShow3] = useState(false)
  const [approveState, setApproveState] = useState(false)
  const [findocState, setFindocState] = useState(false)
  const [prinout, setPrintout] = useState('')
  const [printoutState, setPrinoutState] = useState(true)
  // const [userState, setUserState] = useState("Anper");
  const [userState, setUserState] = useState('Customer')
  const {orderItem, orderItems} = useAppSelector(soSelector)

  const [showApprove, setShowApprove] = useState(false)
  const [showReject, setShowReject] = useState(false)

  const dispath = useDispatch()
  const notif = useSelector((state: any) => state.notif.getNotif)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pickupDate, setPickupDate] = useState(false)

  //#region
  const [SODetail, setSODetail] = useState<any[]>([])
  const [kontrakID, setKontrakID] = useState('')
  const [trans, setTrans] = useState('')
  const [transType, setTransType] = useState('')
  const [transTypeEn, setTransTypeEn] = useState('')
  const [hydro, setHydro] = useState('')
  const [stowage, setStowage] = useState('')
  const [pot, setPot] = useState('')
  const [country, setCountry] = useState('')
  const [countryCode, setCountryCode] = useState('')
  const [province, setProvince] = useState('')
  const [pay, setPay] = useState('')
  const [paySAP, setPaySAP] = useState('')
  const [booking, setBooking] = useState('')
  const [soID, setSOID] = useState('')
  const [rejectNote, setRejectNote] = useState({reason: ''})
  const [assinger, setAssigner] = useState('')
  const [position, setPosition] = useState('')
  const [noExport, setNoExport] = useState('')
  const [assinger2, setAssigner2] = useState('')
  const [position2, setPosition2] = useState('')
  const [ship, setShip] = useState('')
  const [SIP_ID, setSIP_ID] = useState(0)
  const [files, setFiles] = useState({file: null})
  const [fullProvince, setFullProvince] = useState<any[]>([])
  const [trans2, setTrans2] = useState('')
  const [transType2, setTransType2] = useState('')
  const [hydro2, setHydro2] = useState('')
  const [stowage2, setStowage2] = useState('')
  const [pot2, setPot2] = useState('')
  const [country2, setCountry2] = useState('')
  const [province2, setProvince2] = useState('')
  const [pay2, setPay2] = useState('')
  const [roleUser, setRoleUser] = useState('')
  const [kontrak, setKontrak] = useState({
    sip_order: {id: 0},
  })
  const [SIPOrder, setSIPOrder] = useState(0)
  const [fullPayment, setFullPayment] = useState([])
  const [isApprove, setIsApprove] = useState(false)
  const [approvalFlag, setApprovalFlag] = useState(false)
  const [accesses, setAccesses] = useState<any>()
  const [custCode, setCustCode] = useState('')
  const [salesorg, setSalesorg] = useState('')
  const [findocLoc, setFindocLoc] = useState('')
  const [showRevision, setShowRevision] = useState(false)
  const [revisionNote, setRevisionNote] = useState('')
  const [ppn, setppn] = useState(0)
  const [totalquant, setTotalquant] = useState<any>()
  const [priceBefore, setPriceBefore] = useState(0)
  const [priceAfter, setPriceAfter] = useState(0)
  const [payloadPlant, setPayloadPlant] = useState<any[]>([])
  const [plantName, setPlantName] = useState('')
  const [plantID, setPlantID] = useState('')
  const [tempQuant, setTempQuant] = useState(0)
  const [tempIndex, setTempIndex] = useState(0)
  const [idSektor, setIDSector] = useState(0)
  const [sektorId, setSektorId] = useState(0)
  const [regarding, setRegarding] = useState('')
  const [orderSubID, setOrderSubID] = useState(0)
  const [showJadwal, setShowJadwal] = useState(false)
  const [shipCust, setShipCust] = useState<any>('')
  const [totalPcs, setTotalPcs] = useState(0)
  const [tipeProduct, setTipeProduct] = useState('')
  const [unitProduct, setUnitProduct] = useState('')
  const [fileBox, setFileBox] = useState<any>({})
  const [loading, setLoading] = useState(false)
  //#endregion

  const [sailingDate, setSailingDate] = useState<any>(null)
  const [custPICName, setCustPICName] = useState<any>(null)
  const [custPICPosition, setCustPICPosition] = useState<any>(null)
  const [portLoading, setPortLoading] = useState<any>(null)
  const [textBAST, setTextBAST] = useState<any>(null)
  const [textBASTEn, setTextBASTEn] = useState<any>(null)
  const [salesDivision, setSalesDivision] = useState<any>(null)
  const [picSalesDivision, setPicSalesDivision] = useState<any>(null)
  const [TOS, setTOS] = useState<any>(null)
  const [TOSEn, setTOSEn] = useState<any>(null)
  const [TOSsi, setTOSsi] = useState<any>(null)
  const [TOSsiEn, setTOSsiEn] = useState<any>(null)
  const [attn, setAttn] = useState<any>(null)
  const [attnEn, setAttnEn] = useState<any>(null)
  const [penutup, setPenutup] = useState<any>(null)
  const [penutupEn, setPenutupEn] = useState<any>(null)
  const [ETA, setETA] = useState<any>(null)
  const [textKeterangan, setTextKeterangan] = useState<any>(null)
  const [textKeteranganEn, setTextKeteranganEn] = useState<any>(null)
  const [referensi, setReferensi] = useState<any>(null)
  const [referensiEn, setReferensiEn] = useState<any>(null)
  const [shippingInstruction, setShippingInstruction] = useState<any>(null)
  const [invoice, setInvoice] = useState<any>(null)
  const [invoiceEn, setInvoiceEn] = useState<any>(null)
  const [salesorgname, setSalesOrgName] = useState('')
  const [showLetter, setShowLetter] = useState(false)
  const [attachmentType, setAttachmentType] = useState('so-item')
  const [destinationProvince, setDestinationProvince] = useState<any>(null)
  const [destinationProvinceDesc, setDestinationProvinceDesc] = useState<any>(null)
  const [destinationCity, setDestinationCity] = useState<any>(null)
  const [destinationCityDesc, setDestinationCityDesc] = useState<any>(null)
  const [showPreviewForm, setShowPreviewForm] = useState(false)
  const [loadingDownloadDraft, setLoadingDownloadDraft] = useState(false)

  const navigate = useNavigate()
  const params = useParams()
  const SOID = params.id

  const handleShow3 = () => {
    if (approveState != true) setShow3(true)
    else
      swal({
        title: `${t('berhasil')}`,
        icon: 'success',
      })
  }
  const submitApprove = () => {
    setApproveState(true)
    setShow3(false)
  }
  const handleFindoc = () => {
    if (findoc == 'Findoc') setFindocState(true)
    else setFindocState(false)
  }
  const handlePrinout = () => {
    if (prinout == 'Printout CO') setPrinoutState(true)
    else setPrinoutState(false)
  }

  const {t} = useTranslation()

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')

  const [incotermIdDesc, setIncotermIdDesc] = useState('')
  const [incotermId, setIncotermId] = useState(0)
  const [incotermId2, setIncotermId2] = useState('')
  const [custGroup, setCustGroup] = useState('')
  const [custAssign, setCustAssing] = useState('')
  const [custGroup2, setCustGroup2] = useState('')
  const [custAssign2, setCustAssing2] = useState('')
  const [tempDetail, setTempDetail] = useState<any>([])
  const [quantumSO, setQuantumSO] = useState(0)
  const [showDetail, setShowDetail] = useState(false)
  const [city, setCity] = useState('')
  const [city2, setCity2] = useState('')
  const [detailSO, setDetailSO] = useState<any>({})
  const [SAPNum, setSAPNum] = useState<any>()
  const [provinsiTujuan, setProvinsiTujuan] = useState<any>('')
  const [provinsiTujuan2, setProvinsiTujuan2] = useState<any>('')
  const [SONumber, setSONumber] = useState('')
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [customerTitle, setCustomerTitle] = useState('')
  const [imgHeader, setImgHeader] = useState<any>()
  const [imgFooter, setImgFooter] = useState<any>()

  const [showAdditional, setShowAdditional] = useState(false)
  const [addTextLanguage, setAddTextLanguage] = useState('id')
  const [namaPenandatanganFinance, setNamaPenandatanganFinance] = useState<any>(null)
  const [posisiPenandatanganFinance, setPosisiPenandatanganFinance] = useState<any>(null)
  const [sailingDate_, setSailingDate_] = useState<any>('')
  const [shippingInstruction_, setShippingInstruction_] = useState<any>('')
  const [ETA_, setETA_] = useState<any>('')

  const getSODetail = async () => {
    setLoading(true)
    await getDetailSO(params.id, localStorage.getItem('credential')).then((response) => {
      setSONumber(response.data.data.so_number)
      setDetailSO(response.data.data)
      setRegarding(response.data.data.order_sub.regarding)
      setSektorId(response.data.data.sector_id)
      setSalesOrgName(response.data.data.anper?.name)
      getImg(response.data.data.sales_org_code)
      setCustomerCode(response.data.data.customer.customer_code)
      setCustomerName(response.data.data.customer.name)
      setCustomerTitle(
        response.data.data.customer?.title == null ? '' : response.data.data.customer?.title
      )
      setCustomerAddress(response.data.data.customer.address)
      setProvinsiTujuan(response.data.data.province)
      setProvinsiTujuan2(response.data.data.province_desc)
      // sector retail
      setIncotermId(response.data.data.incoterm1_id)
      setIncotermIdDesc(response.data.data.incoterm1?.code)
      setIncotermId2(response.data.data.incoterm2)
      //

      if (response.data.data.sector_id == 2) {
        setEditDisChannel(response.data.data.sip_order?.pengajuan_order?.distribution_channel)
      } else {
        setEditDisChannel(
          response.data.data.contract?.sip_order?.pengajuan_order?.distribution_channel
        )
      }

      const addTexts = response.data.data?.additional_texts
      setSODetail(response.data.data.so_items)
      setKontrakID(response.data.data.contract?.contract_number)
      setTrans(response.data.data.moda_angkut_name)
      setTransType(response.data.data.moda_angkut_type)
      setTransTypeEn(response.data.data.moda_angkut_type_en)
      setHydro(response.data.data.hydro_static_table)
      setStowage(response.data.data.stowage_plan)
      setPot(response.data.data.port_of_discharge)
      setCountry(response.data.data.country_destination)
      setCountryCode(response.data.data.country_code)
      setProvince(response.data.data.province)
      setPay(response.data.data.payment?.code)
      setPaySAP(response.data.data.payment?.code_sap)
      setBooking(response.data.data.booking_code)
      setSOID(response.data.data.id)
      setShip(response.data.data.file_path)
      setSIP_ID(response.data.data.sip_order_id)

      setSAPNum(response.data.data.contract?.sap_number)
      setKontrak(response.data.data.contract)
      setSIPOrder(response.data.data.sip_order_id)

      setTrans2(response.data.data.moda_angkut_name)
      setTransType2(response.data.data.moda_angkut_type)
      setHydro2(response.data.data.file_path_hydro_static_table)
      setStowage2(response.data.data.stowage_plan)
      setPot2(response.data.data.port_of_discharge)
      setCountry2(response.data.data.country_destination)
      setProvince2(response.data.data.sales_office_detail?.region_name)
      setPay2(response.data.data.payment?.payment_desc)
      setDestinationProvince(response.data.data?.province)
      setDestinationProvinceDesc(response.data.data?.province_detail?.region_name)
      setDestinationCity(response.data.data?.city)
      setDestinationCityDesc(response.data.data?.city_detail?.city_name)

      // if (response.data.data.contract == null || response.data.data.contract == '') {
      //   setAssigner(response.data.data.assigner_name)
      //   setAssigner2(response.data.data.assigner_name)
      //   setPosition(response.data.data.assigner_position)
      //   setPosition2(response.data.data.assigner_position)
      // } else {
      //   setAssigner(response.data.data.contract?.assigner_name)
      //   setAssigner2(response.data.data.contract?.assigner_name)
      //   setPosition(response.data.data.contract?.assigner_position)
      //   setPosition2(response.data.data.contract?.assigner_position)
      // }

      if (response.data.data.assigner_name != '' && response.data.data.assigner_name != null) {
        setAssigner(response.data.data.assigner_name)
        setAssigner2(response.data.data.assigner_name)
      } else {
        setAssigner(response.data.data.contract?.assigner_name)
        setAssigner2(response.data.data.contract?.assigner_name)
      }
      if (
        response.data.data.assigner_position != '' &&
        response.data.data.assigner_position != null
      ) {
        setPosition(response.data.data.assigner_position)
        setPosition2(response.data.data.assigner_position)
      } else {
        setPosition(response.data.data.contract?.assigner_position)
        setPosition2(response.data.data.contract?.assigner_position)
      }

      setApprovalFlag(response.data.data.show_btn_approve)

      setIDSector(response.data.data.sector_id)
      setCity(response.data.data.sales_group_detail?.id)
      setCity2(response.data.data.sales_group_detail?.city_name)
      setProvince(response.data.data.sales_office_detail?.id)
      setCustGroup(response.data.data.customer_account_group_detail?.code)
      setCustGroup2(response.data.data.customer_account_group_detail?.name)
      setCustAssing(response.data.data.account_assignment_group_detail?.code)
      setCustAssing2(response.data.data.account_assignment_group_detail?.name)
      setCustCode(response.data.data.customer_id)
      setSalesorg(response.data.data.sales_org_code)
      setFindoc(response.data.data.findoc?.id)
      setShipCust(
        response.data.data.customer_ship?.title == null
          ? response.data.data.customer_ship?.name
          : response.data.data.customer_ship?.title + ' ' + response.data.data.customer_ship?.name
      )
      setFindoc2(response.data.data.findoc?.num_findoc)
      setTOP(response.data.data.term_of_payment?.code)
      setTOP2(response.data.data.term_of_payment?.code)
      setTOPDesc(response.data.data.term_of_payment?.top_desc)
      setTOPDesc2(response.data.data.term_of_payment?.top_desc)
      setFindocLoc(response.data.data.findoc?.file_path)
      setppn(response.data.data.so_items[0].ppn)
      setTotalquant(response.data.data.detail_quantity?.total_tonnase)
      setTotalPcs(response.data.data.detail_quantity?.total_pcs)
      setPriceBefore(response.data.data.price_before_ppn)
      setPriceAfter(response.data.data.price_after_ppn)
      setPickupDate(response.data.data?.contract?.validity_date_to)

      const tempArray: string[] = []
      response.data.data.so_items?.forEach((data: any) => {
        tempArray.push(data.plant_desc)
      })
      setPayloadPlant(tempArray)

      setNoExport(addTexts?.no_izin_export)
      setCustPICName(addTexts?.customer_pic_name)
      setCustPICPosition(addTexts?.customer_pic_position)
      setSailingDate(addTexts?.sailing_date)
      setPortLoading(addTexts?.port_of_loading)
      setTextBAST(addTexts?.additional_text_bast)
      setTextBASTEn(addTexts?.additional_text_bast_en)
      setSalesDivision(addTexts?.sales_division)
      setPicSalesDivision(addTexts?.pic_sales_division)
      setTOS(addTexts?.terms_and_conditions)
      setTOSEn(addTexts?.terms_and_conditions_en)
      setTOSsi(addTexts?.terms_and_conditions_si)
      setTOSsiEn(addTexts?.terms_and_conditions_si_en)
      setAttn(addTexts?.customer_attn)
      setAttnEn(addTexts?.customer_attnEn)
      setPenutup(addTexts?.text_penutup)
      setPenutupEn(addTexts?.text_penutup_en)
      setETA(addTexts?.eta_moda_angkut)
      setTextKeterangan(addTexts?.keterangan)
      setTextKeteranganEn(addTexts?.keteranganEn)
      setReferensi(addTexts?.referensi)
      setReferensiEn(addTexts?.referensi_en)
      setShippingInstruction(addTexts?.tanggal_shipping_instruction)
      setInvoice(addTexts?.invoice_notes)
      setInvoiceEn(addTexts?.invoice_notes_en)
      
      if(response.data.data.show_btn_approve){
        handleShowPreview(response.data.data)
        setShowPreviewForm(true)
      }

      setLoading(false)
    })
  }

  const handleOpenn = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('a')) {
      icon?.classList.remove('a')
      icon?.classList.add('b')
    } else {
      icon?.classList.remove('b')
      icon?.classList.add('a')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    if (fold) {
      fold.classList.toggle('foldd-open')
    }
  }

  function convertDatePicker(date: any) {
    let dd = String(date.getDate()).padStart(2, '0')
    let mm = String(date.getMonth() + 1).padStart(2, '0')
    let yyyy = String(date.getFullYear())
    return yyyy + '-' + mm + '-' + dd
  }

  const handleSaveAdditionalText2 = (id: any, state: any, value: any, state2: any) => {
    state(convertDatePicker(new Date(value.target.value)))
    state2(value.target.value)
  }

  const getImg = async (sales: any) => {
    getDetailFileConfig(sales, 'kop-header').then((res) => {
      setImgHeader(res.data.data)
    })
    getDetailFileConfig(sales, 'kop-footer').then((res) => {
      setImgFooter(res.data.data)
    })
  }

  const separator2 = (value: any, state1: any, state2: any) => {
    const temp = value.split('~#~')
    state1(temp[0])
    state2(temp[1])
  }

  const editPlantSO = async () => {
    await editSOItem(editId, {quantity: tempQuant, plant_desc: plantName, plant: plantID})
      .then((res) => {
        swal({
          title: `${res.data.message}`,
          icon: 'success',
        }).then(() => {
          const tempArray: string[] = [...payloadPlant]
          tempArray[tempIndex] = plantName
          setPayloadPlant(tempArray)
          setShow(false)
        })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${error.response.data.message}`,
            icon: 'error',
          })
        }
      })
  }

  const [top, setTOP] = useState('')
  const [top2, setTOP2] = useState('')
  const [topDesc, setTOPDesc] = useState('')
  const [topDesc2, setTOPDesc2] = useState('')
  const [fullTOP, setFullTOP] = useState([])
  const [allFindoc, setAllFindoc] = useState([])
  const [findoc, setFindoc] = useState('')
  const [findoc2, setFindoc2] = useState('')

  CustomUseEffect(() => {
    if (kontrak == null || kontrak?.sip_order?.id == 0) {
      const getAllPayment = async () => {
        await getPaymentSO(SIPOrder).then((res) => {
          setFullPayment(res.data.data)
        })
      }
      getAllPayment()
    } else {
      // console.log(kontrak)
      const getAllPayment = async () => {
        await getPaymentSO(kontrak?.sip_order?.id).then((res) => {
          setFullPayment(res.data.data)
        })
      }
      getAllPayment()
    }
  }, [kontrak])

  const findPPN = (before: any, after: any) => {
    let ppn = 0.0
    ppn = ((after - before) / before) * 100
    return ppn
  }

  const printoutSO = async (so: any) => {
    await printSO(so).then((response) => {
      // console.log(response.data)
    })
  }

  const condTOP = (top: any) => {
    const trimmedTOP = top.slice(1, 100) + t(' Days')
    if (top != 'Z0LC') return trimmedTOP
    else return 'Letter of Credit TOP'
  }

  CustomUseEffect(() => {
    const getAllFindoc = async () => {
      await getFindoc(custCode, salesorg).then((res) => {
        setAllFindoc(res.data.data)
      })
    }
    getAllFindoc()
    hitTOP()
  }, [custCode])

  CustomUseEffect(() => {
    const getAllPayment = async () => {
      await getPaymentSO(SIPOrder).then((res) => {
          setFullPayment(res.data.data)
        })
    }
    
    if(SIPOrder){
      getAllPayment()
    }
  }, [SIPOrder])

  const separator = (value: any, state1: any, state2: any, state3: any) => {
    const temp = value.split('~#~')
    state1(temp[0])
    state2(temp[1])
    state3(temp[2])
  }

  const hitTOP = async () => {
    if (roleUser == null || roleUser == 'null') {
      await getTOPCust(custCode).then((res) => {
        setFullTOP(res.data.data)
      })
    } else {
      await getTOPAnper().then((res) => {
        setFullTOP(res.data.data)
      })
    }
  }

  const Reject = async () => {
    setBtnLoading(true)
    await rejectSO(parseInt(params.id!), rejectNote)
      .then((res) => {
        dispath(setGetNotif(!notif))

        if (!res.data.error) {
          swal({
            title: `${t('SO Rejected Success')}`,
            icon: 'success',
          })
          navigate('/approval/sales-order')
          setShowReject(false)
        } else
          swal({
            title: `${res.data}`,
            icon: 'error',
          })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const Revision = async () => {
    setBtnLoading(true)
    await revisionSO(parseInt(params.id!), {reason: revisionNote})
      .then((res) => {
        dispath(setGetNotif(!notif))
        if (!res.data.error) {
          swal({
            title: `${t('Berhasil Revisi SO')}`,
            icon: 'success',
          }).then(() => {
            setShowRevision(false)
            navigate('/approval/sip')
          })
        } else
          swal({
            title: `${res.data}`,
            icon: 'error',
          })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => setBtnLoading(false))
  }

  const editAdditionalText = async () => {
      setBtnLoading(true)
      const payload = {
        customer_pic_name: custPICName ? custPICName : '',
        customer_pic_position: custPICPosition ? custPICPosition : '',
        financial_assigner_name: namaPenandatanganFinance || '',
        financial_assigner_position: posisiPenandatanganFinance || '',
        sailing_date: sailingDate ? sailingDate : '',
        port_of_loading: portLoading ? portLoading : '',
        additional_text_bast: textBAST ? textBAST : '',
        sales_division: salesDivision ? salesDivision : '',
        pic_sales_division: picSalesDivision ? picSalesDivision : '',
        terms_and_conditions: TOS ? TOS : '',
        terms_and_conditions_en: TOSEn ? TOSEn : '',
        terms_and_conditions_si: TOSsi ? TOSsi : '',
        terms_and_conditions_si_en: TOSsiEn ? TOSsiEn : '',
        customer_attn: attn ? attn : '',
        customer_attn_en: attnEn ? attnEn : '',
        text_penutup: penutup ? penutup : '',
        text_penutup_en: penutupEn ? penutupEn : '',
        keterangan: textKeterangan ? textKeterangan : '',
        keterangan_en: textKeteranganEn ? textKeteranganEn : '',
        referensi: referensi ? referensi : '',
        referensi_en: referensiEn ? referensiEn : '',
        tanggal_shipping_instruction: shippingInstruction ? shippingInstruction : '',
        invoice_notes: invoice ? invoice : '',
        invoice_notes_en: invoiceEn ? invoiceEn : '',
        eta_moda_angkut: ETA ? ETA : '',
        no_izin_export: noExport ? noExport : '',
        moda_angkut_name: trans ? trans : '',
        moda_angkut_type: transType ? transType : '',
        moda_angkut_type_en: transType2 ? transType2 : '',
        hydro_static_table: hydro ? hydro : '',
        assigner_name: assinger || '',
        assigner_position: position || '',
        port_of_discharge: pot || '',
        country_destination: country,
        province: provinsiTujuan,
        province_desc: provinsiTujuan2,
      }
      swal({
        title: `${t('apakahAndaYakin')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      }).then(async (accept) => {
        if (accept) {
          try{
            setBtnLoading(true)
            await updateAdditionalText(soID, payload).then((res) => {
              setBtnLoading(false)
              swal({
                title: `${t('Data Updated Successfully')}`,
                icon: 'success',
              })
                .then(() => {
                  // navigate('/management/so')
                })
                .catch((err) => {
                  swal({
                    title: 'Error',
                    text: err.response?.data?.message || err?.message,
                    icon: 'error',
                  }).then(() => {})
                })
            })
          }catch(err: any){
            swal({
              title: 'Error',
              text: err.response?.data?.message || err?.message,
              icon: 'error',
            }).then(() => {})
          }
        }
      })
      setBtnLoading(false)
    }

  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [requestQuantum, setReqeustQuantum] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }

    setFixedQuantum(temp)
  }

  const ambilAttachment = async (id: any, type: any = null) => {
    if(type) setAttachmentType(type)
    await getFile(type || attachmentType, id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setShowUpload(true)
    })
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (selectedMenu?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
    // const input3 = document.getElementById("uploadnama") as HTMLInputElement
    // input3.value = ''
    // const input4 = document.getElementById("uploadjenis") as HTMLInputElement
    // input4.value = t('Select file type')
  }

  const removeFileState = () => {
    setFiles({file: null})
    setNamaFile('')
    setDescription('')
    setDataType('')
    setIsPrivate(false)
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (del) => {
      if (del) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(subOrderID)
          })
          .catch((error) => {
            swal({
              title: t(error.response.data.message),
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    // formdata.append('unique_number', SONumber)
    // formdata.append('unique_flag', 'new_so_osd')
    // console.log(formdata)
    await create(attachmentType, formdata)
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          })
          ambilAttachment(subOrderID)
          removeFileState()
          clearInputUpload()
        } else {
          swal({
            title: t(res.data.message),
            icon: 'error',
          })
        }
      })
      .catch(function (error) {
        if (error) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const create2 = async () => {
    setBtnLoading(true)
    let tempID: string[] = []
    let tempquan: string[] = []
    let file = files.file
    let formdata = new FormData()
    formdata.append('moda_angkut_name', trans!)
    formdata.append('moda_angkut_type', transType!)
    formdata.append('hydro_static_table', hydro!)
    formdata.append('stowage_plan', stowage!)
    formdata.append('port_of_discharge', pot!)
    formdata.append('country_destination', country!)
    formdata.append('country_code', countryCode)
    formdata.append('province', province!)
    formdata.append('payment_type', pay!)
    formdata.append('assigner_name', assinger)
    formdata.append('assigner_position', position)
    formdata.append('top', top!)
    formdata.append('findoc_id', findoc!)

    let data = {}
    if (idSektor == 2) {
      data = {
        moda_angkut_name: trans,
        moda_angkut_type: transType,
        hydro_static_table: hydro,
        stowage_plan: stowage,
        port_of_discharge: pot,
        country_destination: country,
        country_code: countryCode,
        payment_type: pay,
        assigner_name: assinger,
        assigner_position: position,
        top: top,
        findoc_id: findoc,
        incoterm1_id: incotermId,
        incoterm2: incotermId2,
        sales_office: province,
        sales_group: city,
        province: province,
        city: destinationCity
      }
    } else {
      data = {
        moda_angkut_name: trans,
        moda_angkut_type: transType,
        hydro_static_table: hydro,
        stowage_plan: stowage,
        port_of_discharge: pot,
        country_destination: country,
        country_code: countryCode,
        payment_type: pay,
        assigner_name: assinger,
        assigner_position: position,
        top: top,
        findoc_id: findoc,
        incoterm1_id: incotermId,
        incoterm2: incotermId2,
        sales_office: province,
        sales_group: city,
        customer_account_group: custGroup,
        account_assignment_group: custAssign,
      }
    }
    let lang = 'en'
    if (i18next.language == 'en') lang = 'en'
    else lang = 'id'
    await approveSO(parseInt(params.id!), localStorage.getItem('credential')!, data, lang)
      .then((response) => {
        dispath(setGetNotif(!notif))

        swal({
          title: `${t(response.data.message)}`,
          icon: 'success',
        }).then(() => {
          navigate('/approval/sales-order')
        })
        setShowApprove(false)
        setIsApprove(true)
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  useEffect(() => {
    const url = window.location.href.split('token=')
    const getAllProvince = async () => {
      await getProvince().then((res) => {
        setFullProvince(res.data.data)
      })
    }

    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    getAccessMenu()
    getAllRoleList()
    role()
    getAllProvince()
    getSODetail()
  }, [])

  const [editId, setEditId] = useState('')
  const [editQuantum, setEditQuantum] = useState('')
  const [editPlant, setEditPlant] = useState('')
  const [editPlantId, setEditPlantId] = useState('')
  const [editPlantDesc, setEditPlantDesc] = useState('')
  const [editMaterialProd, setEditMaterialProd] = useState('')
  const [editDisChannel, setEditDisChannel] = useState('')
  const [fullPlant, setFullPlant] = useState<any[]>([])

  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const handleEditPlant = async (mat: any) => {
    await getPlant2(salesorg, editDisChannel, mat).then((res) => {
      setFullPlant(res.data.data)
    })
    handleShow()
  }

  const editPrice = async (id: any) => {
    const split = editPlant.split(', ')

    setBtnLoading(true)
    axios
      .put(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order/so-item/${editId}`,
        {
          quantity: editQuantum,
          plant: split[0],
          plant_desc: split[1],
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        handleClose()
        swal({
          title: `${t('Data Updated Successfully')}`,
          icon: 'success',
        }).then(() => {
          navigate('/management/so')
        })
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  // const [letterData, setletterData] = useState<any>({})
  const [tempConfig, settempConfig] = useState<any>(null)
  const [tempaccessdata, settempaccessdata] = useState<any>(null)
  const [temp, settemp] = useState<any>([])
  const [tempquantum, settempquantum] = useState<any>(null)
  const [tempTanggal, settempTanggal] = useState<any>(null)
  const [letterData, setLetterData] = useState<any>({})

  useEffect(() => {
    setLetterData({
      lang: i18next.language,
      customer: customerTitle ? customerTitle + ' ' + customerName : customerName,
      configletter: tempConfig,
      address: customerAddress ? customerAddress : '',
      customerAddress: customerAddress || '',
      customerAttn: i18next.language == 'id' ? attn : (attnEn || (attn || '')),
      shippingTolerance_so: orderItems,
      namaAnper: roleUser == 'salesAnper' ? (tempaccessdata?.name ? tempaccessdata.name : '') : '',
      subItem: temp ? temp : [],
      payloadQuantum: tempquantum,
      transport: trans ? trans : '',
      typeTransport: i18next.language == 'en' ? transTypeEn : transType,
      etaTransport: ETA ? ETA : '',
      port: pot ? pot : '',
      portLoading: portLoading ? portLoading : '',
      sektor: sektorId ? sektorId : '',
      kontrakNum: SAPNum ? SAPNum : '',
      sailing: sailingDate ? sailingDate : '',
      bast: i18next.language == 'id' ? textBAST : (textBASTEn || (textBAST || '')),
      sales: salesDivision ? salesDivision : '',
      picSales: picSalesDivision ? picSalesDivision : '',
      term: i18next.language == 'id' ? TOS : (TOSEn || (TOS || '')),
      termSi: i18next.language == 'id' ? TOSsi : (TOSsiEn || (TOSsi || '')),
      ref: i18next.language == 'id' ? referensi : (referensiEn || (referensi || '')),
      tanggalShip: shippingInstruction ? shippingInstruction : '',
      inv: i18next.language == 'id' ? invoice : (invoiceEn|| (invoice || '')),
      textPenutup: i18next.language == 'id' ? penutup : (penutupEn || (penutup || '')),
      keterangan: i18next.language == 'id' ? textKeterangan : (textKeterangan || (textKeterangan || '')),
      footerCon: '',
      contractNumber: SAPNum ? SAPNum : '',
      signername: assinger ? assinger : '',
      singerposition: position ? position : '',
      cusName: custPICName ? custPICName : '',
      cusPosition: custPICPosition ? custPICPosition : '',
      custgroup: custGroup ? custGroup : '',
      batasTanggal: tempTanggal,
      salesorgname: salesorgname ? salesorgname : '',
      sotype: 'detail',
      imgHeader: imgHeader ? imgHeader?.url_file : '',
      imgFooter: imgFooter ? imgFooter?.url_file : '',
    })
  }, [
    imgFooter, imgHeader, salesorgname, tempTanggal, custGroup, custPICPosition, custPICName, position, assinger, SAPNum, i18next, textKeterangan, penutup, penutupEn, invoice, invoiceEn, shippingInstruction, referensi, referensiEn, TOSsi, TOSsiEn, TOS, TOSEn, picSalesDivision, salesDivision, textBAST, textBASTEn, sailingDate, sektorId, portLoading, pot, ETA, transType, transTypeEn, trans, tempquantum, temp, roleUser, orderItems, attn, attnEn, customerAddress, tempConfig, customerTitle, customerName
  ])

  const handleShowPreview = async (_so: any) => {
    let _soDetail = _so.so_items
    let _temp: any[] = []
    let _tempquantum: any[] = []
    _soDetail.forEach((element: any) => {
      _temp.push({
        ...element.order_sub_detail,
        incoterm1_id: element.incoterm1_id,
        incoterm1: element.incoterm1,
        incoterm2_id: element.incoterm2,
        incoterm2: {
          code: element.incoterm2,
          name: element.incoterm2,
        }
      })
      _tempquantum.push({kuantum: element.quantity, index: 0})
    })
    const _tempaccessdata = JSON.parse(localStorage.getItem('accesses')!)
    let tempsales = ''
    let _tempConfig = ''
    let _tempTanggal = _so?.contract?.validity_date_to
    if (salesorg != null && salesorg != undefined) tempsales = salesorg
    else tempsales = ''
    if(sektorId == 2){
      try{
        await getBatasTanggalLetter(totalquant, tempsales, i18next.language, sektorId).then((res) => {
          _tempTanggal = res.data.data
        })
      }catch(e){
        console.log(e)
      }
    }

    await getConfigLetter(tempsales, 'sales-order').then((res) => {
      if (i18next.language === 'en') _tempConfig = res.data.data.english?.content
      else _tempConfig = res.data.data.indonesia?.content
      // setShowLetter(true)
    })

    settemp(_temp)
    settempaccessdata(_tempaccessdata)
    settempquantum(_tempquantum)
    settempTanggal(_tempTanggal)
    settempConfig(_tempConfig)
  }

  const handleDownloadDraft = async () => {
    
    try {

      setLoadingDownloadDraft(true)

      const file_name = detailSO?.status == 6 || detailSO?.status == 7 ? 
        `SO_13${SONumber}_${customerName}.pdf` : 
        `SO_DRAFT_13${SONumber}_${customerName}.pdf`;

      const response = await unduhSO(
        parseInt(params.id!),
        i18next.language
      );

      const href = URL.createObjectURL(response.data)
      const link = document.createElement('a')

      link.href = href
      link.setAttribute('download', file_name)

      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingDownloadDraft(false)

    } catch (error) {

      setLoadingDownloadDraft(false)

      swal({
        title: t('failed'),
        icon: 'error',
      })

    }

  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {t('page Approval SO detail')}
      </PageTitle>
      <div className='card'>
        {/* begin::Header */}
        <div className='card-body mt-2'>
        {loading ? (
            <div className='d-flex justify-content-center py-10'>
              <div className='lds-ellipsis'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            <>
            {
              showPreviewForm && <>
                <div style={{padding: '30px', border: '2px dotted #333'}}>
                  <ViewLetter data={letterData} type='so' />
                </div>

                <div className='my-5 d-flex justify-content-end'>
                  <Button
                    variant='primary'
                    className="ms-2"
                    onClick={() => {
                      setShowUpload(true)
                      setAttachmentType('sales-order')
                      setSubOrderID(SOID || '')
                      ambilAttachment(SOID, 'sales-order')
                    }}
                  >
                    <i className="bi bi-file-earmark-text"></i>
                    {t('order-lampiran')}
                  </Button>
                </div>

                <div className='table-responsive mt-5 bdr'>
                  {/* Table Head */}
                  <TableUI.TableDetail colSpan={14}>
                    <TableUI.TableWrapper style={{marginBottom: 0}}>
                      <TableUI.Table>
                        <TableUI.THead>
                          <tr style={{backgroundColor: '#274070'}}>
                            <th>Sales Org</th>
                            <th>{t('kontrak-incoterm')}</th>
                            <th>{t('order-aksi')}</th>
                            <th>{t('kontrak-wilayah')}</th>
                            <th>{t('kontrak-jenis')}</th>
                            <th>{t('Product Code')}</th>
                            <th>{t('kontrak-nama')}</th>
                            <th>{t('kontrak-spek')}</th>
                            <th>{t('kontrak-kuantum')}</th>
                            {/* {idSektor != 2 ? (<th>{t("Shipping Tolerance")}</th>) : ''} */}
                            <th>{t('Price')}</th>
                            <th>{t('kontrak-hargaPPN')}</th>
                            <th>PPN</th>
                            <th>{t('kontrak-hargaSPPN')}</th>
                            <th>{t('Plant')}</th>
                            <th>{t('Route')}</th>
                          </tr>
                        </TableUI.THead>
                        <TableUI.TBody>
                          {SODetail.map((item: any, _index: number) => (
                            <tr key={item?.id ?? _index}>
                              <td>
                                <div>{item.order_sub_detail?.produsen?.name}</div>
                              </td>
                              <td>
                                <div>
                                  <PopoverText
                                    content={incotermIdDesc + '-' + incotermId2}
                                    index={_index}
                                    className='desc-slicee'
                                  />
                                </div>
                              </td>
                              <td>
                                <div
                                  className='d-flex justify-content-center align-items-center'
                                  style={{padding: '1px 0'}}
                                >
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('order-lampiran')}
                                    onClick={() => {
                                      setFileBox(item?.order_sub_detail)
                                      setSubOrderID(item?.id)
                                      ambilAttachment(item?.id, 'so-item')
                                      setIDSector(item?.order_sub_detail?.sector?.id)
                                      setShowUpload(true)
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/archive-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <PopoverText
                                    content={
                                      item.order_sub_detail?.province?.region_name ||
                                      '' +
                                        (item.order_sub_detail?.city?.city_name
                                          ? ', ' + item.order_sub_detail?.city?.city_name
                                          : '')
                                    }
                                    index={_index}
                                    className='spec-sliceee'
                                  />
                                </div>
                              </td>
                              <td>
                                <div>{item.order_sub_detail?.product_type_desc}</div>
                              </td>
                              <td>
                                <div>
                                  {parseInt(item.order_sub_detail?.material_number) == 0
                                    ? ''
                                    : item.order_sub_detail?.material_number?.slice(-7)}
                                </div>
                              </td>
                              <td>
                                <div>{item.order_sub_detail?.product_name}</div>
                              </td>
                              <td>
                                <div>
                                  <PopoverText
                                    content={
                                      item?.product_spec || item?.order_sub_detail?.product_spec || '-'
                                    }
                                    index={_index}
                                    className='spec-sliceee'
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  {i18next.language === 'en'
                                    ? item.quantity?.toLocaleString('en', {maximumFractionDigits: 4})
                                    : item.quantity?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {item.order_sub_detail.product_type == '8105'
                                    ? ' EA'
                                    : sektorId == 3
                                    ? ' MT'
                                    : ' Ton'}
                                </div>
                              </td>
                              <td>
                                <div>
                                  {sektorId == 3 ? 'USD' : 'Rp'}
                                  {item.price == 0 || item.price == null ? (
                                    <>
                                      {i18next.language === 'en'
                                        ? item?.order_sub_detail?.fixed_price?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item?.order_sub_detail?.fixed_price?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}
                                    </>
                                  ) : (
                                    <>
                                      {i18next.language === 'en'
                                        ? item?.price?.toLocaleString('en', {maximumFractionDigits: 4})
                                        : item?.price?.toLocaleString('id', {maximumFractionDigits: 4})}
                                    </>
                                  )}
                                  /
                                  {item.order_sub_detail.product_type == '8105'
                                    ? item.order_sub_detail.unit
                                    : sektorId == 3
                                    ? 'MT'
                                    : 'Ton'}
                                </div>
                              </td>
                              <td>
                                <div>
                                  {(sektorId == 3 ? 'USD' : 'Rp') + i18next.language === 'en'
                                    ? item.price_before_ppn?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.price_before_ppn?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}
                                </div>
                              </td>
                              <td>
                                <div>{item?.ppn ? item?.ppn : '0'}%</div>
                              </td>
                              <td>
                                <div>
                                  {(sektorId == 3 ? 'USD' : 'Rp') + i18next.language === 'en'
                                    ? item.price_after_ppn?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.price_after_ppn?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}
                                </div>
                              </td>
                              <td>
                                <div>{item.plant_desc}</div>
                              </td>
                              <td>
                                <div>
                                  <PopoverText
                                    content={item.route_desc ? item.route_desc : '-'}
                                    index={_index}
                                    placement='bottom'
                                    className='desc-slicee'
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </TableUI.TBody>
                      </TableUI.Table>
                    </TableUI.TableWrapper>
                  </TableUI.TableDetail>
                  {/* End Table Head */}
                </div>
              </>
            }
            {
              !showPreviewForm && <>
                <Row>
                  <Col md={6}>
                  {(kontrakID || SAPNum) ? (
                    <>
                      <Row>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('kontrak-nomor')} SAP</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            aria-label='Default select example'
                            value={SAPNum}
                            disabled
                          />
                        </Col>
                      </Row>
                    </>
                  ) : (SIP_ID) ? (
                      <>
                        <Row>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('SIP ID')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              aria-label='Default select example'
                              value={String(SIP_ID)}
                              disabled
                            />
                          </Col>
                        </Row>
                      </>
                  ) : (
                    <>
                      <Row>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('SO Number')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            aria-label='Default select example'
                            value={`13${String(SONumber)}`}
                            disabled
                          />
                        </Col>
                      </Row>
                    </>
                  )}

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={customerCode} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>Incoterm</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          disabled
                          size='sm'
                          defaultValue={incotermIdDesc} // add condition for sector except retail
                        />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('sub-order-negara')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={country}
                          disabled
                        />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>Sales Office</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={province2}
                          disabled
                        />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>Sales Group</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={city2}
                          disabled
                        />
                      </Col>
                    </Row>

                    {idSektor != 2 ? (
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Customer Account Group')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control id='' value={custGroup2} disabled size='sm' />
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )}

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>
                          {t('so-jenisAngkut')}
                          {/* <span className='text-danger'>{isApprovalAnper ? '*' : ''}</span> */}
                        </p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          defaultValue={
                            i18next.language == 'en'
                              ? detailSO.moda_angkut_type_en
                              : detailSO.moda_angkut_type
                          }
                          disabled
                          onChange={(e: any) => setTransType(e.target.value)}
                        />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Assigner Name')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control size='sm' value={assinger} disabled={!approvalFlag} onChange={(e: any) => {
                          setAssigner(e.target?.value)
                        }} />
                      </Col>
                    </Row>

                    {transType2 != 'Truk' && (
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('so-rencana')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            aria-label='Default select example'
                            size='sm'
                            value={t(stowage)}
                            disabled
                          />
                        </Col>
                      </Row>
                    )}

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('so-jenisP')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={pay2}
                          disabled
                        />
                      </Col>
                    </Row>

                    {paySAP == 'M' && (
                      <>
                        <Row className='mt-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>Findoc</p>
                          </Col>
                          <Col md={7}>
                            <div className='d-flex align-items-center'>
                              <Form.Control
                                aria-label='Default select example'
                                size='sm'
                                value={findoc2}
                                disabled
                              />
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 px-2'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('unduh')}
                                onClick={() =>
                                  handleDownloadAttachment(findocLoc)
                                }
                              >
                                <KTSVG
                                  path='/media/icons/duotune/arrow-down-square-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}

                    {paySAP == 'M' && (
                      <>
                        <Row className='mt-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>TOP</p>
                          </Col>
                          <Col md={7}>
                            <Form.Select aria-label='Default select example' size='sm' disabled>
                              <option selected disabled hidden>
                                {topDesc2}
                              </option>
                            </Form.Select>
                          </Col>
                        </Row>
                      </>
                    )}

                    {paySAP == 'P' && (
                      <>
                        <Row className='mt-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>TOP</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={topDesc2}
                              disabled
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                    {/* <Row className='mt-3' hidden={shipCust ? false : true}>
                    <Col md={5}>
                    </Col>
                    <Col md={7} className='d-flex justify-content-end'>
                    <Form.Check
                      reverse
                      className='mt-2 mb-2'
                      type='checkbox'
                      id='ckbox-ship'
                      disabled
                      checked={true}
                    />
                    </Col>
                    </Row> */}

                    <Row className='mt-3' hidden={shipCust ? false : true}>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Ship To')}</p>
                      </Col>
                      <Col md={7}>
                        <div className='d-flex' style={{width: '100%'}}>
                          <Form.Control
                            type='text'
                            size='sm'
                            className='w-100'
                            disabled
                            value={shipCust}
                            style={{width: '70%'}}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Address')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          as='textarea'
                          value={customerAddress}
                          disabled
                          size='sm'
                          style={{maxHeight: '40px'}}
                        />
                      </Col>
                    </Row>
                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={customerName} disabled size='sm' />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>Incoterm 2</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          disabled
                          size='sm'
                          defaultValue={incotermId2} // add condition for sector except retail
                        />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('provinsi-tujuan')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          disabled
                          size='sm'
                          value={provinsiTujuan2}
                        />
                      </Col>
                    </Row>

                      {destinationCityDesc && (
                        <Row className='mt-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('destination-city')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              aria-label='Default select example'
                              disabled
                              size='sm'
                              value={destinationCityDesc}
                            />
                          </Col>
                        </Row>
                      )}

                    {idSektor != 2 ? (
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Account Assignment group')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control id='' value={custAssign2} disabled size='sm' />
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )}

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('so-namaAngkut')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={trans}
                          disabled
                        />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Assigner Position')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control size='sm' value={position} disabled={!approvalFlag} onChange={((e: any) => {
                          setPosition(e.target?.value)
                        })} />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Tujuan')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={pot}
                          disabled
                        />
                      </Col>
                    </Row>

                    {sektorId == 2 ? (
                      <Row className='mt-3'>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('so-hydro')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            aria-label='Default select example'
                            size='sm'
                            disabled
                            defaultValue={hydro}
                          />
                        </Col>
                      </Row>
                    ) : (
                      <>
                        {hydro2 == null || hydro == '' ? (
                          ''
                        ) : (
                          <Row className='mt-3'>
                            <Col md={5}>
                              <p className='fs-4 mt-2'>{t('so-hydro')}</p>
                            </Col>
                            <Col md={7}>
                              <Button
                                variant='primary'
                                id='btnupload'
                                onClick={() =>
                                  handleDownloadAttachment(hydro2)
                                }
                              >
                                {t('unduh')}
                              </Button>
                            </Col>
                          </Row>
                        )}
                      </>
                    )}

                    {ship == '' || ship == null ? (
                      ''
                    ) : (
                      <>
                        {transType != 'Truk' && (
                          <Row className='mt-3'>
                            <Col md={5}>
                              <p className='fs-4 mt-2'>{t('so-ship')}</p>
                            </Col>
                            <Col md={7}>
                              <Button
                                variant='primary'
                                id='btnupload'
                                onClick={() =>
                                  handleDownloadAttachment(ship)
                                }
                              >
                                {t('unduh')}
                              </Button>
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </Col>
                </Row>

                <div className='my-5 d-flex justify-content-end'>
                  <Button
                    onClick={() => {
                      setShowLetter(true)
                    }}
                    className='btn btn-primary fw-semibold d-flex align-items-center ms-2'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                    title={t('preview')}
                  >
                    <i className="fa fa-eye"></i>
                    {t('preview')}
                  </Button>
                  <Modal
                    show={showLetter}
                    onHide={() => setShowLetter(false)}
                    size='xl'
                    backdrop='static'
                    keyboard={false}
                    scrollable
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>{t('preview')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <ViewLetter data={letterData} type='so' />
                    </Modal.Body>
                  </Modal>
                  <Button
                    variant='primary'
                    className="ms-2"
                    onClick={() => {
                      setShowUpload(true)
                      setAttachmentType('sales-order')
                      setSubOrderID(SOID || '')
                      ambilAttachment(SOID, 'sales-order')
                    }}
                  >
                    <i className="bi bi-file-earmark-text"></i>
                    {t('order-lampiran')}
                  </Button>

                  {
                    (approvalFlag && hakAkses?.update) && <>
                      <Button
                        className='btn btn-primary ms-2'
                        onClick={() => setShowAdditional(true)}
                      >
                        <i className='fas fa-bars'></i> {t('addtional')} {t('text')}
                      </Button>

                      <Modal
                        show={showAdditional}
                        onHide={() => setShowAdditional(false)}
                        centered
                        backdrop='static'
                        keyboard={false}
                        scrollable
                        size='lg'
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>
                            {t('addtional')} {t('text')}
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div className="d-flex justify-content-end mb-3">
                      <div style={{maxWidth: 140}} className='btn-lang d-flex'>
                        <button
                          className={'d-flex align-items-center me-1 '+ (addTextLanguage == 'id' ? 'active' : '')}
                          onClick={()=> setAddTextLanguage('id')}
                        >
                          <h6 className='ms-1'>Ind</h6>
                        </button>
                        <button
                          className={'d-flex align-items-center me-1 '+ (addTextLanguage == 'en' ? 'active' : '')}
                          onClick={()=> setAddTextLanguage('en')}
                        >
                          <h6 className='ms-1'>Eng</h6>
                        </button>
                      </div>
                    </div>


                    { addTextLanguage == 'id' && <div>
                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'customer pic name'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('customer pic name')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'customer pic name'}>
                              <Form.Control
                                className='mt-3'
                                as='textarea'
                                //maxLength={132}
                                aria-label='Default select example'
                                onChange={(e: any) => setCustPICName(e.target.value)}
                                placeholder={t('customer pic name')}
                                defaultValue={custPICName}
                              />
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer pic name', setCustPICName, custPICName_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'customer pic position'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('customer pic position')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'customer pic position'}>
                              <Form.Control
                                className='mt-3'
                                as='textarea'
                                //maxLength={132}
                                aria-label='Default select example'
                                onChange={(e: any) => setCustPICPosition(e.target.value)}
                                placeholder={t('customer pic position')}
                                defaultValue={custPICPosition}
                              />
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer pic position', setCustPICPosition, custPICPosition_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'nama penandatangan keuangan'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('nama penandatangan keuangan')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'nama penandatangan keuangan'}>
                              <Form.Control
                                className='mt-3'
                                as='textarea'
                                //maxLength={132}
                                aria-label='Default select example'
                                onChange={(e: any) => setNamaPenandatanganFinance(e.target.value)}
                                placeholder={t('nama penandatangan keuangan')}
                                defaultValue={namaPenandatanganFinance}
                              />
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'posisi penandatangan keuangan'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('posisi penandatangan keuangan')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'posisi penandatangan keuangan'}>
                              <Form.Control
                                className='mt-3'
                                as='textarea'
                                //maxLength={132}
                                aria-label='Default select example'
                                onChange={(e: any) => setPosisiPenandatanganFinance(e.target.value)}
                                placeholder={t('posisi penandatangan keuangan')}
                                defaultValue={posisiPenandatanganFinance}
                              />
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'sailing date'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('sailing date')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'sailing date'}>
                              {/* <DatePicker
                            className='form-control'
                            selected={sailingDate_}
                            onChange={(date: any) =>
                              handleSaveAdditionalText2(
                                'sailing date',
                                setSailingDate,
                                date,
                                setSailingDate_
                              )
                            }
                            dateFormat='yyyy/MM/dd'
                          /> */}
                              <Form.Control
                                className='mt-3'
                                type='date'
                                aria-label='Default select example'
                                onChange={(date) =>
                                  handleSaveAdditionalText2(
                                    'sailing date',
                                    setSailingDate,
                                    date,
                                    setSailingDate_
                                  )
                                }
                                placeholder={t('sailing date')}
                                defaultValue={sailingDate}
                              />
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText2('sailing date', setSailingDate, sailingDate_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                      <div className='d-flex align-items-center'>
                        <button
                          className='a btn btn-primary w-100'
                          data-target={'target' + 'port of discharge'}
                          onClick={handleOpenn}
                        >
                          <div className="text-light">{t('port of discharge')}</div>
                        </button>
                      </div>
                      <div className='fold' id={'target' + 'port of discharge'}>
                        <Form.Control
                          className='mt-3'
                          as='textarea'
                          //maxLength={132}
                          aria-label='Default select example'
                          onChange={(e: any) => setPortDischarge(e.target.value)}
                          placeholder={t('port of discharge')}
                          defaultValue={portDischarge}
                        />
                        <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port of discharge', setPortDischarge, portDischarge)}>{t('Save')}</button>
                        </div>
                      </div>
                    </Form.Group> */}

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'port of loading'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('port of loading')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'port of loading'}>
                              <RichText
                                containerClassName='mt-4'
                                content={portLoading}
                                onUpdate={({editor}) => setPortLoading(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port of loading', setPortLoading, portLoading_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'additional text bast'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('additional text bast')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'additional text bast'}>
                              <RichText
                                containerClassName='mt-4'
                                content={textBAST}
                                onUpdate={({editor}) => setTextBAST(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('additional text bast', setTextBAST, textBAST_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'sales division'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('sales division')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'sales division'}>
                              <RichText
                                containerClassName='mt-4'
                                content={salesDivision}
                                onUpdate={({editor}) => setSalesDivision(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('sales division', setSalesDivision, salesDivision_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'pic sales division'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('pic sales division')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'pic sales division'}>
                              <RichText
                                containerClassName='mt-4'
                                content={picSalesDivision}
                                onUpdate={({editor}) => setPicSalesDivision(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('pic sales division', setPicSalesDivision, picSalesDivision_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                      <div className='d-flex align-items-center'>
                        <button
                          className='a btn btn-primary w-100'
                          data-target={'target' + 'transportation media'}
                          onClick={handleOpenn}
                        >
                          <div className="text-light">{t('transportation media')}</div>
                        </button>
                      </div>
                      <div className='fold' id={'target' + 'transportation media'}>
                        <Form.Control
                          className='mt-3'
                          as='textarea'
                          //maxLength={132}
                          aria-label='Default select example'
                          onChange={(e: any) => setTransportMedia_(e.target.value)}
                          placeholder={t('transportation media')}
                          defaultValue={transportMedia}
                        />
                        <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('transportation media', setTransportMedia, transportMedia_)}>{t('Save')}</button>
                        </div>
                      </div>
                    </Form.Group> */}

                          {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                      <div className='d-flex align-items-center'>
                        <button
                          className='a btn btn-primary w-100'
                          data-target={'target' + 'transportation media info'}
                          onClick={handleOpenn}
                        >
                          <div className="text-light">{t('transportation media info')}</div>
                        </button>
                      </div>
                      <div className='fold' id={'target' + 'transportation media info'}>
                        <Form.Control
                          className='mt-3'
                          as='textarea'
                          //maxLength={132}
                          aria-label='Default select example'
                          onChange={(e: any) => setTransportMediaInfo_(e.target.value)}
                          placeholder={t('transportation media info')}
                          defaultValue={transportMediaInfo}
                        />
                        <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('transportation media info', setTransportMediaInfo, transportMediaInfo_)}>{t('Save')}</button>
                        </div>
                      </div>
                    </Form.Group> */}

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'term and condition'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('terms_and_conditions')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'term and condition'}>
                              <RichText
                                containerClassName='mt-4'
                                content={TOS}
                                onUpdate={({editor}) => setTOS(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition', setTOS, TOS_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'term and condition si'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('terms_and_conditions')} SI</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'term and condition si'}>
                              <RichText
                                containerClassName='mt-4'
                                content={TOSsi}
                                onUpdate={({editor}) => setTOSsi(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition si', setTOSsi, TOSsi_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'customer attn'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('customer attn')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'customer attn'}>
                              <RichText
                                containerClassName='mt-4'
                                content={attn}
                                onUpdate={({editor}) => setAttn(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer attn', setAttn, attn_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'text penutup'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('text penutup')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'text penutup'}>
                              <RichText
                                containerClassName='mt-4'
                                content={penutup}
                                onUpdate={({editor}) => setPenutup(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('text penutup', setPenutup, penutup_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'eta moda angkut'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('eta moda angkut')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'eta moda angkut'}>
                              <Form.Control
                                className='mt-3'
                                type='date'
                                aria-label='Default select example'
                                onChange={(date: any) =>
                                  handleSaveAdditionalText2('eta moda angkut', setETA, date, setETA_)
                                }
                                placeholder={t('eta moda angkut')}
                                defaultValue={ETA}
                              />
                              {/* <DatePicker
                            className='form-control'
                            selected={ETA_}
                            onChange={(date: any) =>
                              handleSaveAdditionalText2('eta moda angkut', setETA, date, setETA_)
                            }
                            dateFormat='yyyy/MM/dd'
                          /> */}
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('eta moda angkut', setETA, ETA_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'keterangan'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('keterangan')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'keterangan'}>
                              <RichText
                                containerClassName='mt-4'
                                content={textKeterangan}
                                onUpdate={({editor}) => setTextKeterangan(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('keterangan', setTextKeterangan, textKeterangan_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'referensi'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('referensi')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'referensi'}>
                              <RichText
                                containerClassName='mt-4'
                                content={referensi}
                                onUpdate={({editor}) => setReferensi(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('referensi', setReferensi, referensi_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'tanggal shipping instruction'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('tanggal shipping instruction')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'tanggal shipping instruction'}>
                              <Form.Control
                                className='mt-3'
                                type='date'
                                aria-label='Default select example'
                                onChange={(date: any) =>
                                  handleSaveAdditionalText2(
                                    'tanggal shipping instruction',
                                    setShippingInstruction,
                                    date,
                                    setShippingInstruction_
                                  )
                                }
                                placeholder={t('tanggal shipping instruction')}
                                defaultValue={shippingInstruction}
                              />
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText2('tanggal shipping instruction', setShippingInstruction, shippingInstruction_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'invoice note'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('invoice note')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'invoice note'}>
                              <RichText
                                containerClassName='mt-4'
                                content={invoice}
                                onUpdate={({editor}) => setInvoice(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('invoice note', setInvoice, invoice_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'nomor export'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('nomorIzinExport')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'nomor export'}>
                              <RichText
                                containerClassName='mt-4'
                                content={noExport}
                                onUpdate={({editor}) => setNoExport(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('nomor export', setNoExport, noExport_)}>{t('Save')}</button>
                            </div> */}
                            </div>
                          </Form.Group>
                          <hr />
                    </div> }
                    { addTextLanguage == 'en' && <div>
                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'additional text bast'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('additional text bast')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'additional text bast'}>
                              <RichText
                                containerClassName='mt-4'
                                content={textBASTEn}
                                onUpdate={({editor}) => setTextBASTEn(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('additional text bast', setTextBAST, textBAST_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'term and condition'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('terms_and_conditions')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'term and condition'}>
                              <RichText
                                containerClassName='mt-4'
                                content={TOSEn}
                                onUpdate={({editor}) => setTOSEn(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition', setTOS, TOS_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'term and condition si'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('terms_and_conditions')} SI</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'term and condition si'}>
                              <RichText
                                containerClassName='mt-4'
                                content={TOSsiEn}
                                onUpdate={({editor}) => setTOSsiEn(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition si', setTOSsi, TOSsi_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'customer attn'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('customer attn')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'customer attn'}>
                              <RichText
                                containerClassName='mt-4'
                                content={attnEn}
                                onUpdate={({editor}) => setAttnEn(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer attn', setAttn, attn_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'text penutup'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('text penutup')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'text penutup'}>
                              <RichText
                                containerClassName='mt-4'
                                content={penutupEn}
                                onUpdate={({editor}) => setPenutupEn(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('text penutup', setPenutup, penutup_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'keterangan'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('keterangan')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'keterangan'}>
                              <RichText
                                containerClassName='mt-4'
                                content={textKeteranganEn}
                                onUpdate={({editor}) => setTextKeteranganEn(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('keterangan', setTextKeterangan, textKeterangan_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'referensi'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('referensi')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'referensi'}>
                              <RichText
                                containerClassName='mt-4'
                                content={referensiEn}
                                onUpdate={({editor}) => setReferensiEn(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('referensi', setReferensi, referensi_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />

                          <Form.Group className='mb-3' controlId='formBasicEmail'>
                            <div className='d-flex align-items-center'>
                              <button
                                className='a btn btn-primary w-100'
                                data-target={'target' + 'invoice note'}
                                onClick={(e: any) => handleOpenn(e)}
                              >
                                <div className='text-light'>{t('invoice note')}</div>
                              </button>
                            </div>
                            <div className='fold' id={'target' + 'invoice note'}>
                              <RichText
                                containerClassName='mt-4'
                                content={invoiceEn}
                                onUpdate={({editor}) => setInvoiceEn(editor.getHTML())}
                              >
                                <div style={{display: 'none'}}>&nbsp;</div>
                              </RichText>
                              {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('invoice note', setInvoice, invoice_)}>{t('Save')}</button>
                          </div> */}
                            </div>
                          </Form.Group>
                          <hr />
                    </div> }
                          

                          {/* <div className='d-flex justify-content-end mt-5' >

                      </div> */}
                        </Modal.Body>
                      </Modal>
                    </>
                  }
                </div>

                <div className='table-responsive mt-5 bdr'>
                  {/* Table Head */}
                  <TableUI.TableDetail colSpan={14}>
                    <TableUI.TableWrapper style={{marginBottom: 0}}>
                      <TableUI.Table>
                        <TableUI.THead>
                          <tr style={{backgroundColor: '#274070'}}>
                            <th>Sales Org</th>
                            <th>{t('kontrak-incoterm')}</th>
                            <th>{t('order-aksi')}</th>
                            <th>{t('kontrak-wilayah')}</th>
                            <th>{t('kontrak-jenis')}</th>
                            <th>{t('Product Code')}</th>
                            <th>{t('kontrak-nama')}</th>
                            <th>{t('kontrak-spek')}</th>
                            <th>{t('kontrak-kuantum')}</th>
                            {/* {idSektor != 2 ? (<th>{t("Shipping Tolerance")}</th>) : ''} */}
                            <th>{t('Price')}</th>
                            <th>{t('kontrak-hargaPPN')}</th>
                            <th>PPN</th>
                            <th>{t('kontrak-hargaSPPN')}</th>
                            <th>{t('Plant')}</th>
                            <th>{t('Route')}</th>
                          </tr>
                        </TableUI.THead>
                        <TableUI.TBody>
                          {SODetail.map((item: any, _index: number) => (
                            <tr key={item?.id ?? _index}>
                              <td>
                                <div>{item.order_sub_detail?.produsen?.name}</div>
                              </td>
                              <td>
                                <div>
                                  <PopoverText
                                    content={incotermIdDesc + '-' + incotermId2}
                                    index={_index}
                                    className='desc-slicee'
                                  />
                                </div>
                              </td>
                              <td>
                                <div
                                  className='d-flex justify-content-center align-items-center'
                                  style={{padding: '1px 0'}}
                                >
                                  <button
                                    onClick={() => {
                                      setTempDetail(item)
                                      setQuantumSO(item.quantity)
                                      setShowDetail(true)
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title='Detail'
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/file-text-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('order-lampiran')}
                                    onClick={() => {
                                      setFileBox(item?.order_sub_detail)
                                      setSubOrderID(item?.id)
                                      ambilAttachment(item?.id, 'so-item')
                                      setIDSector(item?.order_sub_detail?.sector?.id)
                                      setShowUpload(true)
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/archive-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  {regarding == 'PO001' ? (
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('Jadwal')}
                                      onClick={() => {
                                        setSektorId(item.order_sub_detail.sector_id)
                                        setProvinceName(item.order_sub_detail.province?.region_name)
                                        setCityName(item.order_sub_detail.city?.city_name)
                                        setProductName(item.order_sub_detail.product_name)
                                        formattingTon(item.order_sub_detail.fixed_quantum)
                                        setTipeProduct(item.order_sub_detail.product_type)
                                        setUnitProduct(item.order_sub_detail.unit)
                                        setOrderSubID(
                                          item.order_sub_detail.order_sub_item_id == null
                                            ? item?.order_sub_detail?.id
                                            : item?.order_sub_detail?.order_sub_item_id
                                        )
                                        setShowJadwal(true)
                                      }}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/calendar-check-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  ) : (
                                    ''
                                  )}
                                  <Modal
                                    show={show}
                                    onHide={handleClose}
                                    backdrop='static'
                                    keyboard={false}
                                  >
                                    <Modal.Header closeButton>
                                      <Modal.Title>
                                        {t('Edit')} {t('Plant')}
                                      </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                                        <Form.Label>{t('Plant')}</Form.Label>
                                        <Form.Select
                                          aria-label='Default select example'
                                          size='sm'
                                          onChange={(e: any) =>
                                            separator2(e.target.value, setPlantID, setPlantName)
                                          }
                                        >
                                          <option selected hidden>
                                            {plantName}
                                          </option>
                                          {fullPlant.map((item: any) => {
                                            return (
                                              <>
                                                <option value={item.plant + '~#~' + item.plant_name}>
                                                  {item.plant_name}
                                                </option>
                                              </>
                                            )
                                          })}
                                        </Form.Select>
                                      </Form.Group>
                                      <div className='d-flex justify-content-end mt-5'>
                                        <Button
                                          className='btn btn-primary'
                                          onClick={editPrice}
                                          disabled={btnLoading}
                                        >
                                          {btnLoading ? (
                                            <Spinner animation='border' variant='light' size='sm' />
                                          ) : (
                                            t('Save')
                                          )}
                                        </Button>
                                      </div>
                                    </Modal.Body>
                                  </Modal>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <PopoverText
                                    content={
                                      item.order_sub_detail?.province?.region_name ||
                                      '' +
                                        (item.order_sub_detail?.city?.city_name
                                          ? ', ' + item.order_sub_detail?.city?.city_name
                                          : '')
                                    }
                                    index={_index}
                                    className='spec-sliceee'
                                  />
                                </div>
                              </td>
                              <td>
                                <div>{item.order_sub_detail?.product_type_desc}</div>
                              </td>
                              <td>
                                <div>
                                  {parseInt(item.order_sub_detail?.material_number) == 0
                                    ? ''
                                    : item.order_sub_detail?.material_number?.slice(-7)}
                                </div>
                              </td>
                              <td>
                                <div>{item.order_sub_detail?.product_name}</div>
                              </td>
                              <td>
                                <div>
                                  <PopoverText
                                    content={
                                      item?.product_spec || item?.order_sub_detail?.product_spec || '-'
                                    }
                                    index={_index}
                                    className='spec-sliceee'
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  {i18next.language === 'en'
                                    ? item.quantity?.toLocaleString('en', {maximumFractionDigits: 4})
                                    : item.quantity?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {item.order_sub_detail.product_type == '8105'
                                    ? ' EA'
                                    : sektorId == 3
                                    ? ' MT'
                                    : ' Ton'}
                                </div>
                              </td>
                              <td>
                                <div>
                                  {sektorId == 3 ? 'USD' : 'Rp'}
                                  {item.price == 0 || item.price == null ? (
                                    <>
                                      {i18next.language === 'en'
                                        ? item?.order_sub_detail?.fixed_price?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item?.order_sub_detail?.fixed_price?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}
                                    </>
                                  ) : (
                                    <>
                                      {i18next.language === 'en'
                                        ? item?.price?.toLocaleString('en', {maximumFractionDigits: 4})
                                        : item?.price?.toLocaleString('id', {maximumFractionDigits: 4})}
                                    </>
                                  )}
                                  /
                                  {item.order_sub_detail.product_type == '8105'
                                    ? item.order_sub_detail.unit
                                    : sektorId == 3
                                    ? 'MT'
                                    : 'Ton'}
                                </div>
                              </td>
                              <td>
                                <div>
                                  {(sektorId == 3 ? 'USD' : 'Rp') + i18next.language === 'en'
                                    ? item.price_before_ppn?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.price_before_ppn?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}
                                </div>
                              </td>
                              <td>
                                <div>{item?.ppn ? item?.ppn : '0'}%</div>
                              </td>
                              <td>
                                <div>
                                  {(sektorId == 3 ? 'USD' : 'Rp') + i18next.language === 'en'
                                    ? item.price_after_ppn?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.price_after_ppn?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}
                                </div>
                              </td>
                              <td>
                                <div>{item.plant_desc}</div>
                              </td>
                              <td>
                                <div>
                                  <PopoverText
                                    content={item.route_desc ? item.route_desc : '-'}
                                    index={_index}
                                    placement='bottom'
                                    className='desc-slicee'
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </TableUI.TBody>
                      </TableUI.Table>
                    </TableUI.TableWrapper>
                  </TableUI.TableDetail>
                  {/* End Table Head */}
                </div>

                {priceBefore != 0 && (
                  <div className='w-50 mt-5'>
                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-3'>Total {t('Quantum')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default example'
                          value={
                            i18next.language === 'en'
                              ? parseFloat(totalquant).toLocaleString('en', {maximumFractionDigits: 4}) +
                                ' Ton'
                              : parseFloat(totalquant).toLocaleString('id', {maximumFractionDigits: 4}) +
                                ' Ton'
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mt-3' hidden={totalPcs == 0 ? true : false}>
                      <Col md={5}>
                        <p className='fs-4 mt-3'>Total {t('sack')}</p>
                      </Col>
                      <Col md={7}>
                        {totalPcs == 0 ? (
                          <Form.Control size='sm' aria-label='Default example' disabled />
                        ) : (
                          <Form.Control
                            aria-label='Default example'
                            key={totalPcs}
                            value={
                              (i18next.language === 'en'
                                ? totalPcs?.toLocaleString('en', {maximumFractionDigits: 4})
                                : totalPcs?.toLocaleString('id', {maximumFractionDigits: 4})) + ' EA'
                            }
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
                      </Col>
                      <Col md={7}>
                        {sektorId != 3 ? (
                          <Form.Control
                            aria-label='Default example'
                            value={
                              i18next.language === 'en'
                                ? 'Rp' + priceBefore.toLocaleString('en', {maximumFractionDigits: 4})
                                : 'Rp' + priceBefore.toLocaleString('id', {maximumFractionDigits: 4})
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control
                            aria-label='Default example'
                            value={
                              i18next.language === 'en'
                                ? 'USD' + priceBefore.toLocaleString('en', {maximumFractionDigits: 4})
                                : 'USD' + priceBefore.toLocaleString('id', {maximumFractionDigits: 4})
                            }
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                    {/* <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-3'>PPN</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          aria-label='Default example'
                          value={(ppn ? ppn : '0') + '%'}
                          disabled
                        />
                      </Col>
                    </Row> */}
                  </div>
                )}

                {priceAfter != 0 && (
                  <div className='w-50 mt-3'>
                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-3'>Total {t('Include')} PPN</p>
                      </Col>
                      <Col md={7}>
                        {sektorId != 3 ? (
                          <Form.Control
                            aria-label='Default example'
                            value={
                              i18next.language === 'en'
                                ? 'Rp' + priceAfter?.toLocaleString('en', {maximumFractionDigits: 4})
                                : 'Rp' + priceAfter?.toLocaleString('id', {maximumFractionDigits: 4})
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control
                            aria-label='Default example'
                            value={
                              i18next.language === 'en'
                                ? 'USD' + priceAfter?.toLocaleString('en', {maximumFractionDigits: 4})
                                : 'USD' + priceAfter?.toLocaleString('id', {maximumFractionDigits: 4})
                            }
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                )}

                <hr/>
              </>
            }

              <div className='d-flex justify-content-between mt-5'>
                <div>
                  <Button className='btn btn-secondary me-2'
                  onClick={() => {
                    if(showPreviewForm){
                      navigate('/approval/sales-order')
                    }else{
                      setShowPreviewForm(true)
                    }
                  }}>
                    <i className="bi bi-chevron-left"></i>
                    {t('cancela')}
                  </Button>
                  { showPreviewForm && 
                    <Button
                      variant='warning'
                      className='ml-2'
                      onClick={() => setShowPreviewForm(false)}
                      disabled={btnLoading}
                    >
                      <i className="fa fa-eye"></i>
                      {t('Detail')}
                    </Button> 
                  }
                  <Button
                    disabled={loadingDownloadDraft}
                    variant='primary'
                    className='ms-2'
                    onClick={handleDownloadDraft}
                  >
                  {
                    loadingDownloadDraft ? <i className='fa fa-spin fa-spinner'></i> : <>
                      <i className='fa fa-download'></i>
                      {[6,7].includes(detailSO?.status) ? t('download-so') : t('download-sip')}
                    </>
                  }
                </Button>
                </div>

                <div>
                  {approvalFlag && showPreviewForm ? (
                    <>
                      {!isApprove ? (
                        <>
                          <Button className='btn btn-danger me-2' onClick={() => setShowReject(true)}>
                          <i className="fa fa-times"></i>
                          {t('order-tolak')}
                          </Button>
                          <Modal
                            show={showReject}
                            onHide={() => setShowReject(false)}
                            centered
                            backdrop='static'
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>{t('order-alasanTolak')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('Tinggal-pesan')}
                                  style={{height: '100px'}}
                                  onChange={(e: any) => setRejectNote({reason: e.target.value})}
                                />
                              </FloatingLabel>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant='secondary' onClick={() => setShowReject(false)}>
                                {t('sip-batal')}
                              </Button>
                              <Button variant='danger' onClick={Reject} disabled={btnLoading}>
                                {btnLoading ? (
                                  <Spinner animation='border' variant='light' size='sm' />
                                ) : (
                                  t('order-tolak')
                                )}
                              </Button>
                            </Modal.Footer>
                          </Modal>

                          {sektorId != 2 && (
                            <>
                            <Button
                              variant='warning'
                              className='me-2'
                              id='btn-revision'
                              onClick={() => setShowRevision(true)}
                            >
                              <i className="fa fa-edit"></i>
                              {t('order-revisi2')}
                            </Button>
                            <Modal
                              show={showRevision}
                              onHide={() => setShowRevision(false)}
                              centered
                              backdrop='static'
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>{t('alasan-revisi')}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('Tinggal-pesan')}
                                    style={{height: '100px'}}
                                    onChange={(e: any) => {
                                      setRevisionNote(e.target.value)
                                    }}
                                  />
                                </FloatingLabel>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant='secondary' onClick={() => setShowRevision(false)}>
                                  {t('sip-batal')}
                                </Button>
                                <Button variant='warning' onClick={Revision} disabled={btnLoading}>
                                  {btnLoading ? (
                                    <Spinner animation='border' size='sm' />
                                  ) : (
                                    t('order-revisi2')
                                  )}
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            </>
                          )}      

                          <Button className='btn btn-success' onClick={() => setShowApprove(true)}>
                          <i className="fa fa-check"></i>
                            {t('setujui')}
                          </Button>
                          <Modal
                            show={showApprove}
                            onHide={() => setShowApprove(false)}
                            centered
                            backdrop='static'
                          >
                            <Modal.Header closeButton></Modal.Header>
                            <Modal.Body>
                              <h3 className='text-center mb-5'>{t('Approve')}?</h3>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant='secondary' onClick={() => setShowApprove(false)}>
                                {t('Tidak')}
                              </Button>
                              <Button variant='success' onClick={() => create2()} disabled={btnLoading}>
                                {btnLoading ? (
                                  <Spinner animation='border' variant='light' size='sm' />
                                ) : (
                                  t('Ya')
                                )}
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </>
                      ) : (
                        <>
                        </>
                      )}
                    </>
                  ) : (
                    (approvalFlag && hakAkses?.update) && <>
                      <Button
                        className='btn btn-warning me-2'
                        onClick={() => editAdditionalText()}
                        disabled={btnLoading}
                      >
                        {btnLoading ? (
                          <Spinner animation='border' variant='light' size='sm' />
                        ) : (
                          <>
                            <i className='fas fa-pencil'></i> Update
                          </>
                        )}
                      </Button>
                    </>
                  )}
                </div>

                <Modal
                  size='lg'
                  show={showUpload}
                  onHide={() => {
                    setShowUpload(false)
                    setTempRole([])
                    setIsPrivate(false)
                    setFileBox({})
                  }}
                  backdrop='static'
                  keyboard={false}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {attachmentType == 'so-item' ? (fileBox?.product_name
                        ? (fileBox.province ? fileBox.province?.region_name : '') +
                          (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                          (fileBox.province ? ' | ' : '') +
                          fileBox.product_name +
                          (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                        : t('File Box')) : <span>{t('File Box')}</span>}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col sm={6}>
                        <table className='mb-3'>
                          <tr>
                            <td style={{width: '120px'}}>
                              <h6>{t('order-fileUnggah')}</h6>
                            </td>
                            <td className='w-75'>
                            <InputFile
                                setFileName={setNamaFile}
                                setFiles={setFiles}
                                isBase64={false}
                            />
                            </td>
                          </tr>
                        </table>
                        <table className='mb-3'>
                          <tr>
                            <td style={{width: '120px'}}>
                              <h6>{t('order-keterangan')}</h6>
                            </td>
                            <td className='w-75'>
                              <Form.Control
                                type='text'
                                placeholder={t('order-keterangan')}
                                id='uploadketerangan'
                                onChange={(e: any) => setDescription(e.target.value)}
                              />
                            </td>
                          </tr>
                        </table>
                        <table className='mb-3'>
                          <tr>
                            <td>
                              <h6 className='me-11'>{t('Private')}</h6>
                            </td>
                            <td className='w-75 d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                name='isPrivate'
                                type='checkbox'
                                className='mt-5 mb-2'
                                onClick={() => {
                                  setIsPrivate(!isPrivate)
                                  setTempRole([])
                                }}
                                id='isPrivate'
                              />
                            </td>
                          </tr>
                        </table>
                        <table className='mb-3' hidden={isPrivate ? false : true}>
                          <tr>
                            <td style={{width: '120px'}}>
                              <h6>{t('Akses Role')}</h6>
                            </td>
                            <td className='w-75' style={{maxWidth: '274px'}}>
                              <MultiSelect
                                key={isPrivate.toString()}
                                options={fullRole?.map((item: any) => {
                                  return {label: item.label, value: item.value}
                                })}
                                value={tempRole}
                                onChange={(e: any) => setTempRole(e)}
                                labelledBy='Select'
                              />
                            </td>
                          </tr>
                        </table>
                        <div className='d-flex justify-content-end'>
                          <Button
                            variant='primary'
                            className='w-100'
                            onClick={() => handleUpload()}
                            disabled={btnLoading}
                          >
                            {btnLoading ? (
                              <Spinner animation='border' variant='light' size='sm' />
                            ) : (
                              t('order-kirim')
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <div className='table-responsive mt-4 bdr'>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        <thead className='fw-bold border-bottom'>
                          <tr className=''>
                            <th className='text-center'>{t('order-noo')}</th>
                            <th className='text-center'>{t('order-keterangan')}</th>
                            <th className='text-center'>{t('order-tglUpload')}</th>
                            {/* <th className='text-center'>{t('User Code')}</th> */}
                            <th className='text-center'>{t('order-user')}</th>
                            <th className='text-center'>{t('Akses Role')}</th>
                            <th className='text-center'>{t('order-aksi')}</th>
                          </tr>
                        </thead>
                        {allFiles.map((data: any, _index: number) => (
                          <tbody key={data?.id ?? _index}>
                            <tr className=''>
                              <td className='text-center'>
                                <label>{_index + 1}</label>
                              </td>
                              <td className='text-center'>
                                <label>{data.description}</label>
                              </td>
                              <td className='text-center'>
                                <label>{dateformat(data.updated_at)}</label>
                              </td>
                              {/* <td className='text-center'>
                                <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                              </td> */}
                              <td className='text-center'>
                                {data.user?.customer_code == null ? (
                                  <label>{data.user?.name}</label>
                                ) : (
                                  <label>{data.user?.customer?.name}</label>
                                )}
                              </td>
                              <td className='text-center'>
                                {data.private ? (
                                  data.roles.length > 0 ? (
                                    <PopoverText
                                      content={handleShowRoleName(data.roles)}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  ) : (
                                    'Private'
                                  )
                                ) : (
                                  'Public'
                                )}
                              </td>
                              <td className='text-center'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                  onClick={() =>
                                    handleDownloadAttachment(
                                      data.file_path
                                    )
                                  }
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                {(hakAkses?.attachment_delete ||
                                  CheckSameIDAttachment(data.user_role_flag)) && (
                                  <button
                                    onClick={() => deleteAttachment(data.id)}
                                    className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Hapus')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/trash-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </table>
                    </div>
                  </Modal.Body>
                </Modal>

                <Modal
                  show={showJadwal}
                  onHide={() => setShowJadwal(false)}
                  centered
                  size='xl'
                  backdrop='static'
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {sektorId != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
                      {productName} | {fixedQuantum} {tipeProduct != '8105' ? 'Ton' : unitProduct}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <span style={{fontSize: '15px'}} className='fw-bold d-block'>
                      {t('Jadwal')}
                    </span>
                    <AddRemoveJadwal id={orderSubID} is_amendment={'false'} tipeproduct={tipeProduct} unit={unitProduct}/>
                  </Modal.Body>
                </Modal>

                <Modal
                  show={showDetail}
                  onHide={() => {
                    setShowDetail(false)
                  }}
                  centered
                  scrollable
                  backdrop='static'
                  size={'xl'}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Detail</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>Sales Org</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={tempDetail?.order_sub_detail?.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control value={incotermIdDesc} type='text' disabled size='sm' />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-3 fs-6'>{tempDetail?.order_sub_detail?.sector_id == 2 ? t('pickup-province') : t('sub-order-provinsi')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              type='text'
                              size='sm'
                              value={tempDetail?.order_sub_detail?.province?.region_name}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={tempDetail?.order_sub_detail?.product_type_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        { tempDetail?.order_sub_detail?.sector_id == 2 && <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-3 fs-6'>{t('destination-province')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              type='text'
                              size='sm'
                              value={tempDetail?.order_sub_detail?.province_dest?.region_name}
                              disabled
                            />
                          </Col>
                        </Row> }
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                (i18next.language === 'en'
                                  ? quantumSO.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : quantumSO.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) +
                                (tempDetail?.order_sub_detail?.sector_id == 3 ? ' MT' : ' Ton')
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              // placeholder={t('Shipping Tolerance')}
                              size='sm'
                              type='text'
                              id='shipping'
                              value={
                                tempDetail?.order_sub_detail?.shipping_tolerance == 0
                                  ? ''
                                  : tempDetail?.order_sub_detail?.shipping_tolerance + '%'
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={tempDetail?.order_sub_detail?.payment_type_1_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('keterangan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={tempDetail?.order_sub_detail?.payment_note}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('End Customer')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                tempDetail?.order_sub_detail?.end_user_multiple
                                  ? handleShowValue(tempDetail?.order_sub_detail?.end_user)
                                  : tempDetail?.order_sub_detail?.end_user
                              }
                              as='textarea'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                tempDetail?.order_sub_detail?.sector_id == 3
                                  ? t('Export')
                                  : tempDetail?.order_sub_detail?.sector_id == 2
                                  ? t('Domestik Retail')
                                  : t('Domestic Korporasi')
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={8}>
                            {tempDetail?.order_sub_detail?.incoterm2 == null ? (
                              <Form.Control
                                value={
                                  tempDetail?.order_sub_detail?.incoterm2_id == null ||
                                  tempDetail?.order_sub_detail?.incoterm2_id == '0'
                                    ? ''
                                    : tempDetail?.order_sub_detail?.incoterm2_id
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={tempDetail?.order_sub_detail?.incoterm2?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{tempDetail?.order_sub_detail?.sector_id == 2 ? t('pickup-city') : t('sub-order-kota')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={tempDetail?.order_sub_detail?.city?.city_name}
                              size='sm'
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={tempDetail?.order_sub_detail?.product_name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        { tempDetail?.order_sub_detail?.sector_id == 2 && <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-3 fs-6'>{t('destination-city')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              type='text'
                              size='sm'
                              value={tempDetail?.order_sub_detail?.city_dest?.city_name}
                              disabled
                            />
                          </Col>
                        </Row> }
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='fs-6 mt-3'>
                              {t('Harga Pengajuan')}/
                              {tempDetail?.order_sub_detail?.sector_id === 3 ? 'MT' : 'Ton'}
                            </p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={
                                (tempDetail?.order_sub_detail?.sector_id === 3 ? 'USD' : 'Rp') +
                                PriceFormater(tempDetail?.order_sub_detail?.fixed_price)
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={8}>
                            <FieldProductSpec
                              data={
                                tempDetail?.product_spec || tempDetail?.order_sub_detail?.product_spec
                              }
                              type='editor'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={tempDetail?.order_sub_detail?.payment_type_2_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row
                          className='mb-4'
                          hidden={tempDetail?.order_sub_detail?.sector_id == 3 ? true : false}
                        >
                          <Col md={4}>
                            <p className='fs-6 mt-3'>{t('segment')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={t(tempDetail?.order_sub_detail?.segment_name)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={tempDetail?.order_sub_detail?.notes}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Modal.Body>
                </Modal>
              </div>
          </>
          )}
        </div>
      </div>
    </>
  )
}

export {ApprovalSODetail}
